import React from "react";
import "./section6.css";

const Sec6 = () => {

  const text = `
  Golden Health Real Estate welcomes you •
  New Project Opening Soon in Sahel •
  25+ Years of Trust •
  50 Premium Units Available •
  Smart Investment Opportunities •
  Modern Coastal Living •
  Luxury Meets Comfort •
  Secure Your Future Today •
  Golden Health Builds Communities •
  Your Next Home Starts Here •
  `;

  return (
    <section className="sec6">
      <div className="sec6-track">
        <div className="sec6-text">{text}</div>
        <div className="sec6-text">{text}</div>
      </div>
    </section>
  );
};

export default Sec6;